module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }, {
      name: "esc",
      rawName: "v-esc",
      value: (_vm.escape),
      expression: "escape"
    }],
    attrs: {
      "transition": _vm.transition
    }
  }, [_c('div', {
    staticClass: "modal",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.clickMask.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    class: {
      'modal-sm': _vm.small, 'modal-lg': _vm.large, 'modal-full': _vm.full, 'modal-auto-height': _vm.autoHeight
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", function() {
    return [_c('a', {
      staticClass: "close",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.cancel
      }
    }, [_vm._v("x")]), _vm._v(" "), _c('h4', {
      staticClass: "modal-title"
    }, [_vm._t("title", function() {
      return [_c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.title)
        }
      })]
    })], 2)]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    style: (_vm.bodyStyle)
  }, [_vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2), _vm._v(" "), (_vm.footer === 'default') ? _c('div', {
    staticClass: "modal-footer text-left"
  }, [_vm._t("footer", function() {
    return [_c('button', {
      staticClass: "pull-right",
      class: _vm.cancelClass,
      attrs: {
        "type": "button"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.cancelText)
      },
      on: {
        "click": _vm.cancel
      }
    }), _vm._v(" "), (_vm.loading) ? _c('i', {
      staticClass: "fa fa-fw fa-lg fa-spin fa-spinner"
    }) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "bold",
      class: _vm.okClass,
      attrs: {
        "type": "button",
        "disabled": _vm.loading || _vm.okDisabled
      },
      domProps: {
        "innerHTML": _vm._s(_vm.okText)
      },
      on: {
        "click": _vm.ok
      }
    })]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.footer === 'custom') ? _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer")], 2) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-backdrop in"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7c73e7d0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bootstrap/ModalBootstrap.vue
// module id = 313
// module chunks = 18